import React from 'react';

import { FilterTypes } from 'app/shared/componentsRestyled/coreDesignSystem/Table/FilterBaseCDS/FilterBaseCDS.constants';
import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { TaskStatus } from 'constants/tasks';
import { getConditionalObject } from 'utils/data';

import TaskHistoryCell from './TaskHistoryCell';

const HISTORY_COLUMN_WIDTH = '90px';

export const getTasksTableConfig = ({
  status,
  taskTypeOptions,
  onOpenTaskHistory,
  onOpenSlaGroupInfo,
}) => {
  const isCanceledTab = status === TaskStatus.CANCELED;

  return {
    name: {
      label: 'Task name',
      width: isCanceledTab ? '22%' : '26%',
      sort: true,
      content: ({ name }) => name,
    },
    taskTypeLabel: {
      label: 'Task type',
      width: isCanceledTab ? '12%' : '16%',
      sort: true,
      filter: {
        selectOptions: taskTypeOptions,
        filterType: FilterTypes.MULTI_SELECT,
      },
      content: ({ taskTypeLabel }) => taskTypeLabel,
    },
    slaGroupName: {
      label: 'SLA Group',
      width: isCanceledTab ? '18%' : '22%',
      sort: true,
      content: ({ slaGroupName }) => slaGroupName,
    },
    assignmentLabel: {
      label: 'Assignment',
      width: isCanceledTab ? '12%' : '14%',
      sort: true,
      content: ({ assignmentLabel }) => assignmentLabel,
    },
    lastModified: {
      label: 'Last modified date',
      width: isCanceledTab ? '18%' : '22%',
      sort: true,
      content: ({ lastModified }) => dayjs(lastModified).format(COMMON_DATETIME_FORMAT),
    },
    ...getConditionalObject(isCanceledTab, {
      userNote: {
        label: 'Cancelation Reason',
        width: '18%',
        sort: true,
        content: ({ userNote }) => userNote,
      },
    }),
    history: {
      label: status === TaskStatus.NEW ? '' : 'History',
      align: 'center',
      width: HISTORY_COLUMN_WIDTH,
      minWidth: HISTORY_COLUMN_WIDTH,
      content: task => (
        <TaskHistoryCell
          status={status}
          task={task}
          onOpenHistory={onOpenTaskHistory}
          onOpenSlaGroupInfo={onOpenSlaGroupInfo}
        />
      ),
    },
  };
};
